export default "__VITE_ASSET__DTj$kyA5__"